import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { VerifiedAccountGuard } from './common/guards/verified-account.guard';
import { LoggedOutGuard } from './common/guards/loggedOutGuard.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'app-center',
    pathMatch: 'full'
  },
  {
    path: 'app-center',
    canActivate: [VerifiedAccountGuard],
    loadChildren: () => import('./components/home/app-center/app-center.module').then( m => m.AppCenterModule)
  },
  {
    path: 'login',
    canActivate: [LoggedOutGuard],
    loadChildren: () => import('./components/home/login/login.module').then( m => m.LoginModule)
  },
  {
    path: '**',
    redirectTo: 'app-center' // redirect to home component if the path don't exist
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
